(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adeqo-language-selector"] && !Shopify.designMode) return;
  try {
    (function() {
  const selector = document.querySelector('.adeqo-language-selector');
  if (!selector) return;

  const trigger = selector.querySelector('.adeqo-language-selector__trigger');
  if (!trigger || trigger.classList.contains('adeqo-language-selector__trigger--static')) return;

  const dropdown = selector.querySelector('.adeqo-language-selector__dropdown');

  trigger.addEventListener('click', () => {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', !isExpanded);
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!selector.contains(e.target)) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  });

  // Keyboard support
  trigger.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
